// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
import { Link } from "react-router-dom";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet";
import {
  Typeset,
  Typepad,
  ImgPad,
  ImgIso,
  BgColor,
  BgColor2,
  DatesRange
} from "../../Partials/Typeset";
import { ThemeColors } from "../../Partials/ThemeColors";
import { Button, ButtonSecondary } from "../../Partials/Button";
import {
  colors,
  sizes,
  expandValue,
  breakpoints
} from "../../../helpers/theme";
import { Footer } from "../../Partials/Ui";
import { Lightbox } from "../../Partials/Lightbox";
import { work } from "../../../helpers/data";
import { slugify } from "../../../helpers/utils";

import { ThemeProvider } from "emotion-theming";
import InViewMonitor from "react-inview-monitor";
import animateScrollTo from "animated-scroll-to";


import img_1 from "../../../images_hd/Olympic/oly-large-home.jpg";
import img_2 from "../../../images_hd/Olympic/oly-large-product.jpg";
import img_3 from "../../../images_hd/Olympic/oly-large-catalog-cms.jpg";
import img_4 from "../../../images_hd/Olympic/oly-large-catalog-img.jpg";
import img_5 from "../../../images_hd/Olympic/oly-large-catalog-grid.jpg";
import img_6 from "../../../images_hd/Olympic/oly-large-catalog-list-lg.jpg";
import img_7 from "../../../images_hd/Olympic/oly-large-login.jpg";
import img_8 from "../../../images_hd/Olympic/oly-large-orders.jpg";
import img_9 from "../../../images_hd/Olympic/oly-large-dashboard.jpg";
import img_10 from "../../../images_hd/Olympic/oly-large-orders-dets.jpg";

var tinycolor = require("tinycolor2");
var $ = require("jquery");

let GridStyles = props => css`
  @media (min-width: ${expandValue(breakpoints[2])}) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-column-gap: ${expandValue(sizes.space * 2)};
  }
`;
let Grid = styled("div")`
  ${GridStyles}
`;

let ImgGridStyles = props => css`
  padding: ${expandValue(sizes.space)};
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  @media (min-width: ${expandValue(breakpoints[2])}) {
    padding: ${expandValue(sizes.space * 2)};
    .bg-image {
      background-size: cover;
    }
  }
`;
let ImgGridS = styled("div")`
  ${ImgGridStyles}
`;

let CardStyles = props => css`
  @media (min-width: ${expandValue(breakpoints[3])}) {
    display: grid;
    grid-template-columns: 50% 50%;
  }
`;
let Card = styled("article")`
  ${CardStyles}
`;

// Get me only this project
let workit = work.filter(work => work.component === "WorkOlympic");

export class CardOlympic extends React.Component {
  render() {
    let desc =
      "Design multiple Magento storefronts for retail and wholesale sunglasses sales.";
    if (this.props.desc) {
      desc = this.props.desc;
    }
    return (
      <Card>
        <div css={{ gridColumn: "1/2" }}>
          <BgColor2 style={{ height: "100%" }}>
            <Typepad>
              <Typeset>
                <h2 style={{ marginBottom: 0 }}>Olympic Eyewear</h2>
                <h4 className="line">Schawel+Coles</h4>

                <p className="text-lg">{desc}</p>
                <ul className="list-inline tags">
                  {workit[0].tags.map((tag, index) => (
                    <li key={"tag_" + index}>
                      <Link to={"/t/" + slugify(tag)}>{tag}</Link>
                    </li>
                  ))}
                </ul>

                <DatesRange>2013&ndash;2014</DatesRange>
                <Link to="/work/olympic">
                  <Button>View</Button>
                </Link>
              </Typeset>
            </Typepad>
          </BgColor2>
        </div>
        <div style={{ gridColumn: "2/3" }}>
          <ImgIso dropShadow>
            <ImgPad>
              <Link to="/work/olympic">
                <img src={img_1} alt="Olympic Eyewear Screenshot" />
              </Link>
            </ImgPad>
            <ImgPad>
              <Link to="/work/olympic">
                <img src={img_2} alt="Olympic Eyewear Screenshot" />
              </Link>
            </ImgPad>
          </ImgIso>
        </div>
      </Card>
    );
  }
}

export class WorkOlympic extends React.Component {
  constructor(props) {
    super(props);
    this.state = { enableTheme: false };
  }
  enableTheme(inView) {
    //console.log("inView",inView.isIntersecting)
    this.setState({ enableTheme: true });
  }
  disableTheme(inView) {
    //console.log("inView",inView.isIntersecting)
    this.setState({ enableTheme: false });
  }

  render() {
    let hue = 358;
    let sat = 90;
    let lit = 50;

    let blendSpin = 10;

    let colorBlack = tinycolor("hsl(" + hue + ", " + sat + "%, 5%)").toString();
    let colorWhite = colors.white;

    let colorPrimary = tinycolor(
      "hsl(" + hue + ", " + sat + "%, " + lit + "%)"
    ).toString();

    let colorSecondary = tinycolor(colorPrimary)
      .spin(blendSpin)
      .toString();

    let colorBackground1 = "#57585b";
    let colorBackground2 = "#404145";
    let colorBackground3 = colorBackground1;
    let colorBackground4 = colorBackground1;
    let colorBackground5 = colorBackground2;
    let colorBackground6 = colorBackground2;

    const enableTheme = this.state.enableTheme;
    let doTheDamnTheme;

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        blendSpin: 0,
        bg1: colorBackground1,
        bg2: colorBackground2
      }
    };

    if (enableTheme) {
      // Set browser color
      $("meta[name=theme-color]").remove();
      $("head").append(
        '<meta name="theme-color" content="' + colorBackground2 + '">'
      );

      doTheDamnTheme = (
        <ThemeColors
          white={colorWhite}
          black={colorBlack}
          color={colorPrimary}
          color2={colorSecondary}
          logoColor1={colorPrimary}
          logoColor2={colorSecondary}
          bg1={colorBackground1}
          bg2={colorBackground2}
          bg3={colorBackground3}
          bg4={colorBackground4}
          bg5={colorBackground5}
          bg6={colorBackground6}
        />
      );
    } else {
      doTheDamnTheme = "";
    }

    return (
      <ThemeProvider theme={theme}>
        <InViewMonitor
          intoViewMargin={"-50%"}
          repeatOnInView={true}
          onInView={inView => this.enableTheme(inView)}
          onNotInView={inView => this.disableTheme(inView)}
        >
          {doTheDamnTheme}

          <article data-name="olympic">
            <BgColor2>
              <Typepad pageTop>
                <Typeset>
                  <Grid>
                    <div style={{ gridColumn: "1/6" }}>
                      <h2 style={{ marginBottom: 0 }}>Olympic Eyewear</h2>
                      <h4 className="line">Schawel+Coles</h4>
                    </div>
                    <div style={{ gridColumn: "1/6" }}>
                      <p className="text-lg">
                        Design multiple Magento storefronts for retail and
                        wholesale sunglasses sales. The interface allows B2B
                        customers to rapidly add large quantities of items to
                        the cart using only the SKU.
                      </p>
                      <ul className="list-inline tags">
                        {workit[0].tags.map((tag, index) => (
                          <li key={"tag_" + index}>
                            <Link to={"/t/" + slugify(tag)}>{tag}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div
                      css={{
                        button: { width: "100%" },
                        ".date": { width: "100%" },
                        gridColumn: "6/7"
                      }}
                    >
                      <DatesRange>2013&ndash;2014</DatesRange>
                      <Link to="/work/olympic">
                        <Button>View</Button>
                      </Link>
                    </div>
                  </Grid>
                </Typeset>
              </Typepad>
            </BgColor2>

            <BgColor>
              <ImgIso dropShadow>
                <ImgGridS>
                  <div style={{ gridColumn: "1/4" }}>
                    <ImgPad>
                      <Link to="/work/olympic">
                        <img src={img_1} alt="Olympic Eyewear Screenshot" />
                      </Link>
                    </ImgPad>
                    <ImgPad>
                      <Link to="/work/olympic">
                        <img src={img_2} alt="Olympic Eyewear Screenshot" />
                      </Link>
                    </ImgPad>
                    <ImgPad>
                      <Link to="/work/olympic">
                        <img src={img_3} alt="Olympic Eyewear Screenshot" />
                      </Link>
                    </ImgPad>
                  </div>
                  <div style={{ gridColumn: "4/7" }}>
                    <ImgPad>
                      <Link to="/work/olympic">
                        <img src={img_4} alt="Olympic Eyewear Screenshot" />
                      </Link>
                    </ImgPad>
                    <ImgPad>
                      <Link to="/work/olympic">
                        <img src={img_5} alt="Olympic Eyewear Screenshot" />
                      </Link>
                    </ImgPad>
                    <ImgPad>
                      <Link to="/work/olympic">
                        <img src={img_6} alt="Olympic Eyewear Screenshot" />
                      </Link>
                    </ImgPad>
                  </div>
                </ImgGridS>
              </ImgIso>
            </BgColor>
          </article>
        </InViewMonitor>
      </ThemeProvider>
    );
  }
}

export class PageWorkOlympic extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      images: [
        {
          image: img_1,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_2,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_3,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_4,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_5,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_6,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_7,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_8,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_9,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        },
        {
          image: img_10,
          bg: "#f7faff",
          size: "weblg",
          alt: "Olympic Eyewear Screenshot"
        }
      ]
    };
  }

  componentDidMount() {
    const options = {
      // duration of the scroll per 1000px, default 500
      speed: 200,
      // minimum duration of the scroll
      minDuration: 0,
      // maximum duration of the scroll
      maxDuration: 200
    };
    animateScrollTo(0, options);
    $("#Top").addClass("Banished");
  }

  render() {
    let hue = 358;
    let sat = 90;
    let lit = 50;

    let blendSpin = 10;

    let colorBlack = tinycolor("hsl(" + hue + ", " + sat + "%, 5%)").toString();
    let colorWhite = colors.white;

    let colorPrimary = tinycolor(
      "hsl(" + hue + ", " + sat + "%, " + lit + "%)"
    ).toString();

    let colorSecondary = tinycolor(colorPrimary)
      .spin(blendSpin)
      .toString();

    let colorBackground1 = "#57585b";
    let colorBackground2 = "#404145";
    let colorBackground3 = colorBackground1;
    let colorBackground4 = colorBackground1;
    let colorBackground5 = colorBackground2;
    let colorBackground6 = colorBackground2;

    const theme = {
      colors: {
        white: colorWhite,
        black: colorBlack,
        primary: colorPrimary,
        secondary: colorSecondary,
        button1: colorPrimary,
        button2: colorSecondary,
        tertiary: colors.tertiary,
        complimentary: colors.complimentary,
        text: colors.text,
        blendSpin: 0,
        bg1: colorBackground1,
        bg2: colorBackground2
      }
    };

    $("meta[name=theme-color]").remove();
    $("head").append(
      '<meta name="theme-color" content="' + colorBackground2 + '">'
    );

    return (
      <ThemeProvider theme={theme}>
        <Helmet>
          <title>
            Case Study | Olympic Eyewear - Jesse Stewart | User Interface
            Designer
          </title>
          <meta
            itemprop="description"
            content="The Portfolio of Jesse Stewart, Staff Software Engineer and UX/UI Designer in East Lansing, Michigan."
          />
        </Helmet>
        <div css={{ width: "100%" }}>
          <ThemeColors
            white={colorWhite}
            black={colorBlack}
            color={colorPrimary}
            color2={colorSecondary}
            logoColor1={colorPrimary}
            logoColor2={colorSecondary}
            bg1={colorBackground1}
            bg2={colorBackground2}
            bg3={colorBackground3}
            bg4={colorBackground4}
            bg5={colorBackground5}
            bg6={colorBackground6}
          />

          <BgColor2>
            <Typepad pageTop>
              <Typeset>
                <Grid>
                  <div style={{ gridColumn: "1/6" }}>
                    <h1 style={{ marginBottom: 0 }}>Olympic Eyewear</h1>
                    <h4 className="line">Schawel+Coles</h4>
                  </div>
                  <div style={{ gridColumn: "1/6" }}>
                    <p className="text-lg">
                      Design multiple Magento storefronts for retail and
                      wholesale sunglasses sales. The interface allows B2B
                      customers to rapidly add large quantities of items to the
                      cart using only the SKU.
                    </p>
                    <ul className="list-inline tags">
                      {workit[0].tags.map((tag, index) => (
                        <li key={"tag_" + index}>
                          <Link to={"/t/" + slugify(tag)}>{tag}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div
                    css={{
                      button: { width: "100%" },
                      ".date": { width: "100%" },
                      gridColumn: "6/7"
                    }}
                  >
                    <DatesRange>2013&ndash;2014</DatesRange>
                    <Link to="/?p=olympic">
                      <ButtonSecondary>
                        Back
                      </ButtonSecondary>
                    </Link>
                  </div>
                </Grid>
              </Typeset>
            </Typepad>
          </BgColor2>

          <ImgGridS>
            <div style={{ gridColumn: "1/7" }}>
              {this.state.images.map((image, index) => (
                <ImgPad dropShadow key={"Lightbox_" + index}>
                  <Lightbox images={this.state.images} currentIndex={index} />
                </ImgPad>
              ))}
            </div>
          </ImgGridS>

          <BgColor>
            <Typepad style={{ textAlign: "center" }}>
              <Link to="/?p=olympic">
                <ButtonSecondary>
                  Back to Portfolio
                </ButtonSecondary>
              </Link>
            </Typepad>
          </BgColor>

          <Footer />
        </div>
      </ThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Work/Olympic.js